import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {PresenterProps, withPresenter} from '../../../Support/with_presenter';
import {CrewInvitesPresenter} from './CrewInvitesPresenter';
import {NetworkRequestStatus} from '../../../Network/NetworkResult';
import {classNames} from '../../Support/classNames';

interface OwnProps {
    className?: string;
}

const CrewInvitesComponent: FunctionComponent<OwnProps & PresenterProps<CrewInvitesPresenter>> = observer(
    ({className, presenter}) => {
        if (presenter.invites.status === NetworkRequestStatus.Loading) {
            return null;
        }
        if (presenter.invites.status === NetworkRequestStatus.Error) {
            return (
                <div className={classNames('card', className)}>
                    <div className="card-title">
                        <h5>Crew invites</h5>
                    </div>
                    <div className="card-body">
                        <p>There was an error loading your crew invites.</p>
                    </div>
                </div>
            );
        }
        if (presenter.invites.data.length === 0) {
            return null;
        }
        return (
            <div className={classNames('card', className)}>
                <div className="card-title">
                    <h5>Crew invites</h5>
                </div>
                <div className="card-body">
                    <p>You have been invited to a crew! Join them by accepting the invite</p>
                    {presenter.invites.data.map((invite) => {
                        return (
                            <div className="mb-3">
                                <div className="row">
                                    <div className="col-12">
                                        <strong>{invite.crew.name}</strong>
                                        <p>{invite.crew.description}</p>
                                        <div className="d-flex flex-row justify-content-between">
                                            <button
                                                className="btn btn-danger"
                                                onClick={() => {
                                                    if (confirm('Are you sure you want to decline this invite?')) {
                                                        presenter.onDeclineInviteClick(invite);
                                                    }
                                                }}
                                            >
                                                Decline
                                            </button>
                                            <button
                                                className="btn btn-primary"
                                                onClick={() => presenter.onAcceptInviteClick(invite)}
                                            >
                                                Accept
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    },
);

export const CrewInvites = withPresenter<CrewInvitesPresenter, OwnProps>(
    (props, component) => new CrewInvitesPresenter(component.network.crews),
    CrewInvitesComponent,
);
